 angular
   .module('vppApp')
   .directive('scrollToDirective', scrollToDirective);

 scrollToDirective.$inject = ['ScrollToService'];

 function scrollToDirective(ScrollToService) {
   return {
     restrict: "AC",
     compile: function() {

       return function(scope, element, attr) {
         element.bind("click", function(event) {
           //clear storage
           window.localStorage.removeItem("idOrName_");
           window.localStorage['idOrName_'] = attr.scrollToDirective;
           ScrollToService.idOrName(attr.offset);

         });
       };
     }
   };
 }